import React from "react";
import PropTypes from "prop-types";
import useSourcePath from "./use-source-path";
import Thumbnail from "../thumbnail";

const SourceThumbnail = ({ source, imageHash = null, refreshed = false, ...props }) => {
  const path = useSourcePath(source.id, refreshed);
  return <Thumbnail path={path} sizeX={1920} sizeY={1080} {...props} />;
};

SourceThumbnail.propTypes = {
  /**
   * Source to show thumbnail for
   **/
  source: PropTypes.object,
  /**
   * Width of the asset
   **/
  width: PropTypes.number,
  /**
   * Sets the with to 100%
   **/
  fullwidth: PropTypes.bool,
  /**
   * Indica si la imagen es la obtenida directamente de la cámara o la almacenada
   **/
  refreshed: PropTypes.bool,
  /**
   * Image hash for browser cache to reload
   **/
  imageHash: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SourceThumbnail;
